import { render, staticRenderFns } from "./OciDateInput.vue?vue&type=template&id=254fb612&scoped=true&"
import script from "./OciDateInput.vue?vue&type=script&lang=js&"
export * from "./OciDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254fb612",
  null
  
)

export default component.exports